import { render, staticRenderFns } from "./recordTables.vue?vue&type=template&id=73f2cc46&scoped=true&"
import script from "./recordTables.vue?vue&type=script&lang=js&"
export * from "./recordTables.vue?vue&type=script&lang=js&"
import style0 from "./recordTables.vue?vue&type=style&index=0&id=73f2cc46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f2cc46",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
